/** The part of the signed-in user these checks read: roles with their permissions (names or objects). */
export type UserWithRoles = { roles?: { permissions?: (string | { name?: string })[] }[] } | null | undefined;

/** Permission names the signed-in user holds across their roles (as returned with the user). */
export const userPermissionNames = (user: UserWithRoles): Set<string> =>
  new Set<string>(
    (user?.roles ?? []).flatMap((r) => (r.permissions ?? []).map((p) => (typeof p === 'string' ? p : p?.name ?? ''))),
  );

/** Platform administrator (site admin / superadmin): holds system:superadmin, which only global roles carry. */
export const isPlatformAdmin = (user: UserWithRoles): boolean => userPermissionNames(user).has('system:superadmin');
